/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Image_Pod_Automation_TaglineInputs */

const en_svc_ai_image_pod_automation_tagline = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate designs, mockups and listings, then publish to your store automatically.`)
};

const ar_svc_ai_image_pod_automation_tagline = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أنشئ التصاميم والنماذج والقوائم، ثم انشرها في متجرك تلقائيا.`)
};

const bn_svc_ai_image_pod_automation_tagline = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডিজাইন, মকআপ আর লিস্টিং তৈরি করুন, তারপর আপনার স্টোরে স্বয়ংক্রিয়ভাবে প্রকাশ করুন।`)
};

const de_svc_ai_image_pod_automation_tagline = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generieren Sie Designs, Mockups und Listings und veröffentlichen Sie sie dann automatisch in Ihrem Shop.`)
};

const es_svc_ai_image_pod_automation_tagline = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generar diseños, maquetas y anuncios, y publicarlos en su tienda automáticamente.`)
};

const fr_svc_ai_image_pod_automation_tagline = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générez designs, maquettes et annonces, puis publiez-les automatiquement dans votre boutique.`)
};

const pt_svc_ai_image_pod_automation_tagline = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gere designs, maquetas e anúncios e publique-os automaticamente na sua loja.`)
};

const zh_svc_ai_image_pod_automation_tagline = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`批量生成设计、效果图和 listing，然后自动上架到你的店铺。`)
};

const tr_svc_ai_image_pod_automation_tagline = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasarımları, maketleri ve listelemeleri üretin, mağazanıza otomatik yayınlayın.`)
};

const ru_svc_ai_image_pod_automation_tagline = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Генерируйте дизайны, мокапы и листинги, затем публикуйте в свой магазин автоматически.`)
};

const pl_svc_ai_image_pod_automation_tagline = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generuj projekty, mockupy i listingi, potem publikuj w sklepie automatycznie.`)
};

/**
* | output |
* | --- |
* | "Generate designs, mockups and listings, then publish to your store automatically." |
*
* @param {Svc_Ai_Image_Pod_Automation_TaglineInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_image_pod_automation_tagline = /** @type {((inputs?: Svc_Ai_Image_Pod_Automation_TaglineInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Image_Pod_Automation_TaglineInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_image_pod_automation_tagline(inputs)
	if (locale === "bn") return bn_svc_ai_image_pod_automation_tagline(inputs)
	if (locale === "de") return de_svc_ai_image_pod_automation_tagline(inputs)
	if (locale === "es") return es_svc_ai_image_pod_automation_tagline(inputs)
	if (locale === "fr") return fr_svc_ai_image_pod_automation_tagline(inputs)
	if (locale === "pt") return pt_svc_ai_image_pod_automation_tagline(inputs)
	if (locale === "zh") return zh_svc_ai_image_pod_automation_tagline(inputs)
	if (locale === "tr") return tr_svc_ai_image_pod_automation_tagline(inputs)
	if (locale === "ru") return ru_svc_ai_image_pod_automation_tagline(inputs)
	if (locale === "pl") return pl_svc_ai_image_pod_automation_tagline(inputs)
	return en_svc_ai_image_pod_automation_tagline(inputs)
});
export { svc_ai_image_pod_automation_tagline as "svc_ai-image-pod-automation_tagline" }